import React from 'react'
import {render} from 'react-dom'
import toast from 'util/toast'
import {bind} from 'router/subscribe'
import store from 'store'
import {loadCurrentAdmin} from 'util/admin-session-api'
require('./polyfill')
require('./css/index.css')

window.addEventListener('unhandledrejection', event => {
    // Prevent error output on the console:
    event.preventDefault();
    console.log('Reason: ' + event.reason);
})

function init() {
  let App = require('./ui/App').default
  render(<App />, document.getElementById('app'))
  bind()
  loadCurrentAdmin().then(user => {
    store.finishAuthentication(user)
  }, () => {
    store.finishAuthentication(null)
  })
}

const app = document.getElementById('app')
if (app) {
  if (!window.localStorage) {
    toast('检测不到缓存模块，请关闭隐私模式后刷新页面', {type: 'error'})
  } else {
    init()
  }
}
